import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAlertProps, selectOpen, setOpen, selectIsError } from "./globalSnackbarSlice";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { useStyles } from "./globalSnackbarStyle";
export default function GlobalSnackbar(): ReactElement {
  const classes = {
    ...useStyles(),
  };

  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectOpen);
  const alertProps = useAppSelector(selectAlertProps);
  const isError = useAppSelector(selectIsError);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setOpen(false));
  };

  const mailDestination = process.env.REACT_APP_BTC_MAIL
  const sendEmailHandler = () => {
    //eslint-disable-next-line scanjs-rules/assign_to_href
    window.location.href = `mailto:${mailDestination}?subject=Fehler in Anwendung PowerQuality&body=
    Uhrzeit: ${alertProps.dateAndTime} %0D%0A
    Url: ${alertProps.requestUrl} %0D%0A
    HTTP Code: ${alertProps.statusCode} %0D%0A
    Request ID: ${alertProps.xRequestID}`
  }

  return (
    <div>
      <Snackbar
        open={isOpen}
        autoHideDuration={alertProps.duration}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={alertProps.severity}>
          <b>{alertProps.title}</b>
          {alertProps.message}
        { isError ? <div className={classes.sendEmailContainer}> <div className={classes.sendEmailBtn} onClick={sendEmailHandler}><MailOutlineIcon style={{height: "16px", width: "16px", marginRight: "12px"}}/>Ticket beim Service Desk eröffnen</div></div> : ""}
        </Alert>
      </Snackbar>
    </div>
  );
}
